import React from 'react';
import { ButtonBase, Typography } from '@mui/material';
import appColors from '../app_colors';

const embeddedButtonStyle = {
  color: appColors.text.navy,
  fontSize: 'inherit',
  fontFamily: 'inherit',
  fontWeight: 700,
  verticalAlign: 'baseline',
};

export const TextWithEmbeddedButton = ({
  text,
  buttonText,
  onClick,
  sx,
}) => {
  const indexOfButton = text.indexOf(buttonText);
  const firstPart = text.slice(0, indexOfButton);
  const secondPart = text.slice(indexOfButton + buttonText.length);

  return (
    <Typography sx={sx}>
      {firstPart}
      <ButtonBase sx={embeddedButtonStyle} onClick={onClick} disableRipple>
        {buttonText}
      </ButtonBase>
      {secondPart}
    </Typography>
  );
};
